"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const data_1 = require("../../../data");
const categories = (0, graphql_tag_1.default)`
  ${data_1.pageInfoFields}
  query docs_page_doc_categories($before: Int, $after: Int, $first: Int, $last: Int) {
    documents {
      categories(before: $before, after: $after, first: $first, last: $last) {
        edges {
          node {
            id
            name
            isProtected
            canEdit
            canDelete
          }
          cursor
        }
        pageInfo {
          ...pageInfoFields
        }
        totalCount
      }
    }
  }
`;
exports.default = categories;